/**extracts viewer information from the bridge url and composes the embed url
 * @example viewer url: https://d35cat4w6cwz4j.cloudfront.net/BRIDGE/index.htm?type=360&viewer=CD2C440F-2978-48A2-8EDD-F62D0C0C0B40/CD2C440F-2978-48A2-8EDD-F62D0C0C0B40
 * @example embed url: https://d35cat4w6cwz4j.cloudfront.net/360/DF2D61FF-E748-4A5D-93C4-3EBD6A9150EE/DF2D61FF-E748-4A5D-93C4-3EBD6A9150EE.htm
 */
const parse360Url = (viewerUrl) => {
  const pathArray = viewerUrl?.split?.("/");
  const protocol = pathArray?.[0] || "";
  const host = pathArray?.[2] || "";
  const baseUrl = protocol + "//" + host;

  const params = new URLSearchParams(viewerUrl);
  const viewer = params.get("viewer");

  if ((!baseUrl, !viewer)) return "";

  const embedUrl = `${baseUrl}/360/${viewer}.htm`;
  return embedUrl;
};

export default parse360Url;
